import React, { useState, useEffect } from "react";
import "./NotificationBadge.css"; // Import custom styles
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../helper";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setMessage } from "../../redux/slice/message/messageSlice";
import { baseUrl } from "../../services/api";
import { useMessages } from "../../context/chat/chat-context";
import { useNotification } from "../../context/notifications/notifications-context";

const NotificationBadge = ({
  count,
  children,
  isNotificationsOpen,
  isMessagesOpen,
  loggedInUser,
  messages,
  type,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getUnreadCount, markMessageAsRead } = useMessages(); // message
  const {
    fetchNotifications,
    notifications: contextNotifications,
    loading,
    markAsRead,
    unreadCount,
  } = useNotification();

  const [messagesCount, setMessagesCount] = useState(0);

  useEffect(() => {
    if (isMessagesOpen) {
      const allMessagesCount = getUnreadCount(loggedInUser?.id);
      setMessagesCount(allMessagesCount);
    }
    // eslint-disable-next-line
  }, [isMessagesOpen, loggedInUser?.id]);

  useEffect(() => {
    Promise.resolve(fetchNotifications());
    // eslint-disable-next-line
  }, [isNotificationsOpen]);

  const handleMessage = (message) => {
    dispatch(setMessage(message));
    navigate(`/${loggedInUser.role}/messages`);
  };

  const unreadNotifications = unreadCount || 0;
  const unreadMessages = messages?.filter((m) => !m.seen)?.length || 0;
  const unreadMessagesCount = messages?.reduce((acc, chat) => acc + (chat.unreadCount || 0), 0);

  const getBadgeCount = () => {
    if (type === "notifications") {
      return unreadNotifications > 0 ? unreadNotifications : null;
    }

    if (type === "messages") {
      // return unreadMessages ? unreadMessages : null;
      return unreadMessagesCount ? unreadMessagesCount : null;
    }

    return null;
  };
  const badgeCount = getBadgeCount();

  return (
    <>
      <div className="notification-badge-wrapper">
        {children}
        {badgeCount !== null && (
          <span className="notification-badge-count">
            {badgeCount > 9 ? "9+" : badgeCount}
          </span>
        )}
      </div>
      {isNotificationsOpen && (
        <div className="notification-container" style={{ zIndex: "9" }}>
          <div className="notification-box">
            <div className="notification-header">
              {/* <h3>fi</h3> */}
              <h3
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  fontFamily: "Poppins",
                }}
              >
                Notifications
              </h3>
            </div>
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  height: "200px", // Adjust height as needed
                }}
              >
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : contextNotifications?.length > 0 ? (
              <div className="notification-list m-2">
                {contextNotifications?.map((item) => (
                  <div
                    key={item?.id}
                    className={`notification-item mb-1 ${
                      item.isRead ? "bg-gradient" : "bg-light"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "10px",
                      padding: "8px 5px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <p
                        className={`title ${
                          item.isRead ? "fw-normal" : "fw-bold"
                        }`}
                        style={{ marginBottom: 4 }}
                      >
                        {capitalizeFirstLetter(item?.type)} notification{" "}
                        {!item.isRead && (
                          <span
                            className="d-inline-block rounded-circle bg-primary"
                            style={{ width: "8px", height: "8px" }}
                          ></span>
                        )}
                      </p>
                      <p className="message">
                        {item?.description.length > 20
                          ? item.description.slice(0, 20) + "..."
                          : item.description}
                      </p>
                      <p className="time">
                        {moment(new Date(item?.createdAt?.seconds * 1000))
                          .startOf("hour")
                          .fromNow()}
                      </p>
                    </div>
                    {!item.isRead && (
                      <div
                        // className="mark-as-read"
                        style={{
                          color: "#007bff",
                          cursor: "pointer",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          marginLeft: 8,
                          alignSelf: "flex-start",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          markAsRead(item.id);
                        }}
                      >
                        Mark as Read
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No notifications</p>
              </div>
            )}
            <div className="notification-footer">
              <button
                onClick={() => {
                  dispatch(setMessage({}));
                  navigate(`/${loggedInUser?.role}/notifications`);
                }}
              >
                View all Notification
              </button>
            </div>
          </div>
        </div>
      )}

      {isMessagesOpen && (
        <div className="notification-container" style={{ zIndex: "9" }}>
          <div className="notification-box">
            <div className="notification-header">
              <h3
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  fontFamily: "Poppins",
                }}
              >
                Messages
              </h3>
            </div>
            {messages?.length > 0 ? (
              <div className="notifications-list m-2">
                {messages?.map((x) => (
                  <div
                    key={x?.id}
                    className={`notification-item mb-1 ${
                      x?.seen ? "bg-gradient" : "bg-light"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      padding: "8px 5px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleMessage(x)}
                  >
                    <img
                      src={
                        x?.lastMessage?.receiverProfileUrl
                          ? `${baseUrl}/${x?.lastMessage?.receiverProfileUrl}`
                          : require("../../assets/images/avatar.jpg")
                      }
                      alt="User"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        objectFit: "cover",
                        marginRight: 10,
                      }}
                    />

                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 500 }}>
                        {!x.seen && (
                          <span
                            className="d-inline-block rounded-circle bg-primary"
                            style={{
                              width: "8px",
                              height: "8px",
                              marginRight: "8px",
                            }}
                          ></span>
                        )}
                        {x?.fullName}
                      </div>
                      <div style={{ color: "#666", fontSize: "13px" }}>
                        {x?.message}
                      </div>
                      <div style={{ color: "#999", fontSize: "12px" }}>
                        {x?.timestamp}
                      </div>
                    </div>

                    {/* Mark as Read */}
                    {!x?.seen && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          markMessageAsRead?.(x?.chatId);
                        }}
                        style={{
                          color: "#007bff",
                          cursor: "pointer",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          marginLeft: 8,
                          alignSelf: "flex-start",
                        }}
                      >
                        Mark as read
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No messages</p>
              </div>
            )}
            <div className="notification-footer">
              <button
                onClick={() => {
                  dispatch(setMessage({}));
                  navigate(`/${loggedInUser.role}/messages`);
                }}
              >
                View all messages
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationBadge;
